import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart, PieController, ArcElement, CategoryScale, Tooltip, Legend } from 'chart.js';

Chart.register(PieController, ArcElement, CategoryScale, Tooltip, Legend);

const PieChart = ({ data, onPieClick }) => {
	const chartData = {
        labels: ["", "", "", "", ""],
        datasets: [
            {
                data: data,
                backgroundColor: ["#f2ee84", "#a0d080", "#90b9e2", "#3f3f92", "#9b61c1", "white", "red"],
                radius: "50%",
                borderWidth: 1,
                borderColor: "rgba(0, 0, 0, 0.3)",
            },
        ],
    };

	const options = {
		plugins: {
			legend: {
				display: false,
			},
		},
	};

	return <Pie data={chartData} options={options} />;
};

export default PieChart;